<template>
  <div class="links">
    <div class="wrapper">
      <h1>Полезные ссылки</h1>
      <ul class="links__list" v-if="this.arrayLinks && this.arrayLinks.length">
        <li class="links__item" v-for="(link, indexLink) in arrayLinks" :key="indexLink">
          <span class="links__name">{{link.name}}:&nbsp;</span>
          <a :href="link.href" :title="link.name" target="_blank" class="links__link">{{link.href}}</a>
          <p class="links__text" v-if="link.text">{{link.text}}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "Links",
  data () {
    return {
      arrayLinks: []
    }
  },
  methods: {
    linksCreate () {
      this.arrayLinks = [
        {
          name: 'Проверка разметки (валидатор)',
          href: 'http://validator.w3.org/',
          text: ''
        },
        {
          name: 'Сжатие картинок: jpg и png',
          href: 'https://tinypng.com/',
          text: ''
        },
        {
          name: 'Типограф для текста (html)',
          href: 'https://www.artlebedev.ru/typograf/',
          text: ''
        },
        {
          name: 'Оптимизация файла css',
          href: 'https://refresh-sf.com/',
          text: ''
        },
        {
          name: 'Конвертер шрифтов',
          href: 'http://onlinefontconverter.com/',
          text: ''
        },
        {
          name: 'Генератор favicon.ico',
          href: 'https://www.favicon.by/',
          text: ''
        }
        ,
        {
          name: 'reCaptcha от Google',
          href: 'https://www.google.com/recaptcha/admin',
          text: ''
        },
        {
          name: 'Бесплатные svg-иконки',
          href: 'https://icon-icons.com/',
          text: ''
        },
        {
          name: 'Шрифты (в том числе и web)',
          href: 'https://webfonts.pro/base-web-fonts/',
          text: ''
        }
      ]
    }
  },
  mounted () {
    this.linksCreate()
  }
}
</script>

<style lang="scss">
  .links {
    position: relative;

    &__list {
      display: block;
      position: relative;
    }

    &__item {
      display: block;

      & + & {
        margin: 20px 0 0;

        @media screen and (min-width: 480px){
          margin: 15px 0 0;
        }
      }
    }

    &__name {
      display: block;

      @media screen and (min-width: 480px){
        display: inline;
      }
    }

    &__link {
      display: block;
      margin: 5px 0 0;

      @media screen and (min-width: 480px){
        display: inline;
      }
    }

    &__text {
      margin: 5px 0 0;
      @include font(12px, 16px, $color-gray);

      @media screen and (min-width: 480px){
        padding: 0 0 0 30px;
      }
    }
  }
</style>